module.exports = __webpack_public_path__ + "img/home-kurs-4.2689d28b.png";